import {Component} from 'panel';

import {registerMPElement} from '../../util/register-element';
import {SelectEvent, ToggleIconSide} from './types';

import css from './index.styl?inline';
import template from './index.jade';

export default registerMPElement(
  `mp-toggle`,
  class extends Component<{}> {
    static get attrsSchema() {
      return {
        ...super.attrsSchema,
        blue: {type: `boolean`, deprecatedMsg: `Use attr color='blue' instead`},
        color: {type: `string`, enum: [`blue`, `grey`]},
        large: {type: `boolean`, deprecatedMsg: `Use attr size='large' instead`},
        selected: `string`,
        size: {type: `string`, enum: [`large`, `small`]},
        small: {type: `boolean`, deprecatedMsg: `Use attr size='small' instead`},
        square: {type: `boolean`, deprecatedMsg: `Use attr theme='square' instead`},
        theme: {type: `string`, enum: [``, `lite`, `square`]},
        spacing: {type: `number`, description: `amount of spacing around toggle options`},
        options: {type: `json`, description: `toggle options`, interface: `ToggleOption[]`},
      };
    }

    get config() {
      return {
        css,
        template,
        useShadowDom: true,

        helpers: {
          ToggleIconSide,

          selectOption: (value) => {
            this.selectOption(value);
          },

          // NOTE: querying slotted children for options is a deprecated method. Pass options via json attr.
          // attr changes always result in an update -> render.
          // if something changes the slotted children, the tab won't re-render causing all sorts of ui glitches.
          toggleOptions: () =>
            this.attr(`options`)
              ? this.attr(`options`)
              : Array.from(this.children)
                  .filter((el) => el.tagName.toLowerCase() === `mp-toggle-option`)
                  .map((el) => {
                    const icon = el.getAttribute(`icon`);
                    return {
                      disabled: this.isAttributeEnabled.call(el, `disabled`),
                      error: this.isAttributeEnabled.call(el, `error`),
                      icon,
                      label: el.textContent,
                      value: el.getAttribute(`value`),
                    };
                  }),

          getStyleOverride: (optionIdx) => {
            if (this.attr(`spacing`)) {
              const margin = `${this.attr(`spacing`)}px`;
              return {
                'margin-right': margin,
                ...(optionIdx === 0 ? {'margin-left': margin} : {}),
              };
            } else {
              return {};
            }
          },
        },
      };
    }

    get value() {
      return this.attr(`selected`);
    }

    selectOption(value: string) {
      this.dispatchEvent(new CustomEvent(`select`, {detail: {selected: value}}) as SelectEvent);
    }
  },
);
